import React, { useEffect, useState } from "react";
import { Button, Col, Container, Input, Row, Spinner, Table } from "reactstrap";

import { MdDelete, MdEdit, MdPlayArrow } from "react-icons/md";
import "../../../assets/css/AutomationWorkflows.css";
import workflow from "../../../models/workflow";
import comum from "../../../helpers/comum";
import { toast } from "react-toastify";
import ModalParamRun from "./ModalParamRun";

function AutomationWorkflows() {
  const [workflows, setWorkflows] = useState([]);

  const [modalRun, setModalRun] = useState(null);
  const [actualPipeline, setActualPipeline] = useState(null);
  const [load, setLoad] = useState(false);

  const [lastResult, setLastResult] = useState(null);

  async function init() {
    setLoad(true);
    const data = await workflow.getAll();
    setWorkflows(data);
    setLoad(false);
  }

  const mountPipeline = (form) => {
    let finalNodes = actualPipeline?.nodes ?? [];
    if (form) {
      finalNodes = actualPipeline.nodes?.map((e) => {
        return {
          ...e,
          params: e.params?.map((f) => {
            if (form[f.id]) {
              return { ...f, value: form[f.id] };
            }
            return f;
          }),
        };
      });
    }
    return {
      ...actualPipeline,
      nodes: finalNodes,
    };
  };

  const _runPipeline = async (form = null) => {
    setLoad(true);
    const body = mountPipeline(form);
    const res = await workflow.run(body);
    setLastResult(res);
    if (res.status) {
      toast.success(
        "Workflow executado com sucesso. Duração: " +
          comum.calculateDuration(res.start_date, res.end_date)
      );
    } else {
      toast.error("Ouve um erro ao executar a pipeline.");
    }
    setLoad(false);
  };

  const runPipeline = async (pipeline) => {
    setLastResult(null);

    const paramsVazios = pipeline.nodes
      ?.map((e) => e.params)
      .flatMap((e) => e)
      .filter((e) => e.type === "input")
      .filter((e) => !e.value || e.value === "");
    setActualPipeline(pipeline);
    if (paramsVazios.length != 0) setModalRun(paramsVazios);
    else _runPipeline();
  };

  const newPipeline = async () => {
    const res = await workflow.save({
      id: null,
      title: `Novo workflow - ${new Date().toISOString()}`,
      edges: [],
      nodes: [],
    });

    if (!res) {
      toast.error("Não foi possivel criar um novo workflow, tente novamente.");
      return;
    }

    comum.Redirect(`/flows/${res.id}`);
  };

  useEffect(() => {
    init();
  }, []);

  if (workflows.length === 0)
    return (
      <div className="total-edit">
        <Row className="justify-content-center align-items-center mt-6 main-workflows">
          {!load ? (
            <Col xs={12} md={10} className="text-center">
              <h4 className="mb-4">Workflows de Automação</h4>
              <img
                src="https://img.freepik.com/free-vector/cartoon-exhausted-woman-sitting-table-working_74855-6943.jpg"
                alt="Imagem ilustrativa de workflows de automação"
                className="img-fluid"
                style={{ width: "100%" }}
              />
              <p className="mt-4">Simplifique seus processos com automação!</p>
              <p>
                Crie, visualize e gerencie workflows que automatizam suas
                tarefas de forma eficiente.
              </p>
              <div className="mt-5">
                <Button
                  color="primary"
                  tabIndex="0"
                  onClick={() => newPipeline()}
                >
                  Criar Workflow
                </Button>
              </div>
            </Col>
          ) : (
            <Spinner size="lg" color="primary" />
          )}
        </Row>
      </div>
    );

  return (
    <>
      <Container>
        <div className="">
          <Col className="mt-4">
            <h4 className="mb-4">
              Workflows de Automação
              <span style={{ fontWeight: "200" }}>({workflows?.length})</span>
            </h4>

            <div className="sm-1">
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ width: "30%" }}>
                  <Input
                    type="text"
                    placeholder="Buscar Workflow"
                    className="mb-2"
                  />
                </div>
                <div className="float-right">
                  <Button
                    color="primary"
                    tabIndex="0"
                    onClick={() => newPipeline()}
                  >
                    Novo Workflow
                  </Button>
                </div>
              </div>
            </div>

            <Table
              className="mt-1 table-press-workflows"
              bordered
              responsive
              striped
              summary="Lista de workflows de automação"
            >
              <thead>
                <tr>
                  <th>
                    <div role="button" tabIndex="0">
                      Nome do Workflow
                    </div>
                  </th>
                  <th>
                    <div role="button" tabIndex="0">
                      Data de Alteração
                    </div>
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {workflows
                  ?.filter((e) => e?.id)
                  ?.map((e) => (
                    <tr key={e.id}>
                      <td>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                          }}
                        >
                          <a
                            aria-disabled="false"
                            href={`/flows/${e.id}`}
                            tabIndex="0"
                            className="workflow-link"
                          >
                            {e.title}
                          </a>
                          {/* <Badge color="success" style={{ paddingTop: 5 }}>
                        Ativo
                      </Badge> */}
                        </div>
                      </td>
                      <td className="col-3">
                        <div className="date">
                          <p>
                            {new Date(
                              e.updated_at ?? e.created_at
                            ).toLocaleDateString()}
                          </p>
                        </div>
                      </td>
                      <td className="col-2">
                        <div
                          style={{
                            display: "flex",
                            gap: 10,
                            justifyContent: "center",
                          }}
                        >
                          <Button
                            color="success"
                            className="statistics-button"
                            onClick={() => runPipeline(e)}
                          >
                            <MdPlayArrow size={16} />
                          </Button>
                          <Button
                            color="primary"
                            className="statistics-button"
                            onClick={() => {
                              comum.Redirect(`/flows/${e.id}`);
                            }}
                          >
                            <MdEdit />
                          </Button>
                          <Button
                            type="button"
                            color="danger"
                            disabled
                            className="statistics-button"
                          >
                            <MdDelete />
                          </Button>{" "}
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </Col>
        </div>
      </Container>
      <ModalParamRun
        modal={modalRun}
        setModal={setModalRun}
        onRun={(form) => _runPipeline(form)}
        load={load}
        lastResult={lastResult}
      />
    </>
  );
}

export default AutomationWorkflows;
